import Component from "./component"
import Header from "./header"

export default {
  Component,
  Header,
}
